"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_router_dom_1 = require("react-router-dom");
const navigation_1 = __importDefault(require("@App/navigation"));
const clsx_1 = __importDefault(require("clsx"));
const common_1 = require("@Const/common");
const react_1 = __importDefault(require("react"));
const PublicSearchNavLink = () => (react_1.default.createElement(react_router_dom_1.NavLink, { to: navigation_1.default.search.root(), className: ({ isActive }) => (0, clsx_1.default)('icon-button', isActive && 'active'), title: 'Public Search' },
    react_1.default.createElement("img", { src: common_1.ICONS.workSearch, alt: "search" })));
exports.default = PublicSearchNavLink;
